import {format, parseISO} from "date-fns";

import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {IsItDownServiceStatusPill, PublicProfilesGroupIncident} from "@/lib/types/isitdown.ts";
import {MarketingTable} from "@/marketingPages/components/marketingtable/MarketingTable.tsx";

import styles from "./IncidentHistory.module.scss";

interface IncidentHistoryProps {
  incidents: PublicProfilesGroupIncident[];
}

export const IncidentHistory = ({incidents}: IncidentHistoryProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Incident History</div>
      <MarketingTable
        variant="white"
        overlay={
          <a href={`${URL_ORIGINAL_WEBSITE}/accounts/register`} className={styles.overlay}>
            Sign Up to View Full Incident History →
          </a>
        }
        rows={incidents}
        specs={[
          {
            fieldName: "title",
            fieldTitle: "INCIDENT NAME",
            meta: {columnClassName: styles.incidentNameColumn},
          },
          {
            fieldName: "status",
            fieldTitle: "CURRENT STATUS",
            accessor: ({status}) => (
              <StatusPill type="checks" variant="textAndIcon" status={IsItDownServiceStatusPill[status]} />
            ),
            meta: {columnClassName: "text-nowrap"},
          },
          {
            fieldName: "created_at",
            fieldTitle: "STARTED",
            accessor: ({created_at}) => format(parseISO(created_at), "PP pp"),
            meta: {columnClassName: "text-nowrap"},
          },
          {
            fieldName: "updated_at",
            fieldTitle: "LAST UPDATE",
            accessor: ({updated_at}) => format(parseISO(updated_at), "PP pp"),
            meta: {columnClassName: "text-nowrap"},
          },
        ]}
      />
    </div>
  );
};
